import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import CookieBanner from "@/components/site/CookieBanner";
import Home from "@/pages/Home";
import Apply from "@/pages/Apply";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";
import Login from "@/pages/Login";
import Blog from "@/pages/Blog";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Cookies from "@/pages/legal/Cookies";
import CommunicationsConsent from "@/pages/legal/CommunicationsConsent";
import ESignConsent from "@/pages/legal/ESignConsent";
import ApplicationAuthorization from "@/pages/legal/ApplicationAuthorization";
import WebsiteDisclaimer from "@/pages/legal/WebsiteDisclaimer";
import PrivacyRequest from "@/pages/PrivacyRequest";
import BrokerVerify from "@/pages/BrokerVerify";
import HowItWorks from "@/pages/HowItWorks";
import Admin from "@/pages/Admin";
import Dashboard from "@/pages/Dashboard";

function Layout({ children }) {
  return (
    <div className="App min-h-screen flex flex-col">
      <div className="bg-[#F3D8DA] text-[#2A1C14]" data-testid="top-achievement-banner">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-2.5 text-center">
          <p className="font-serif-lux text-sm sm:text-base tracking-wide leading-snug">
            America's <span className="italic">#1</span> Top Producing Female Broker · <span className="italic">$1B</span> in Investment Sales &amp; Financing
          </p>
        </div>
      </div>
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <CookieBanner />
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/apply" element={<Layout><Apply /></Layout>} />
          <Route path="/how-it-works" element={<Layout><HowItWorks /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          <Route path="/faq" element={<Layout><FAQ /></Layout>} />
          <Route path="/login" element={<Layout><Login /></Layout>} />
          <Route path="/blog" element={<Layout><Blog /></Layout>} />
          <Route path="/privacy" element={<Layout><Privacy /></Layout>} />
          <Route path="/terms" element={<Layout><Terms /></Layout>} />
          <Route path="/cookies" element={<Layout><Cookies /></Layout>} />
          <Route path="/communications-consent" element={<Layout><CommunicationsConsent /></Layout>} />
          <Route path="/esign-consent" element={<Layout><ESignConsent /></Layout>} />
          <Route path="/application-authorization" element={<Layout><ApplicationAuthorization /></Layout>} />
          <Route path="/disclaimer" element={<Layout><WebsiteDisclaimer /></Layout>} />
          <Route path="/privacy-request" element={<Layout><PrivacyRequest /></Layout>} />
          <Route path="/broker-verify/:token" element={<Layout><BrokerVerify /></Layout>} />
          <Route path="/dashboard" element={
            <ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>
          } />
          <Route path="/admin/applications" element={
            <ProtectedRoute requireRole="admin"><Admin /></ProtectedRoute>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
